import { DiscoveryKeyword } from '@teko/discovery';
import { ThemeProps } from '@teko/ds-desktop';
import { Text } from '@teko/ecommerce/mobile';
import { getTrackingData } from '@teko/tracking';
import { styled, SvgIcon } from '@teko/ui';
import { t } from 'i18n';
import React from 'react';

interface SearchRecentProps {
  histories: DiscoveryKeyword[];
  onRemoveSearchHistories: () => void;
  onSearch: (keywordObj: DiscoveryKeyword) => void;
  onHoverItem: (item: number) => void;
  selected: number | null;
}
const StyledSearchTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
`;
const StyledSearchItem = styled.div(
  (props: { selected: boolean }) => `
  display: flex;
  padding: 0.6rem;
  cursor: pointer;
  background: ${props.selected ? '#f5f5f5' : '#fff'};
  border-radius: 8px;
`,
);
const StyledRemoveHistory = styled.div(
  (props: ThemeProps) => `
  cursor: pointer;
  color: #848788;
  &:hover {
    color: ${props.theme?.colors.primary};
  }
`,
);
const StyledIcon = styled(SvgIcon)`
  min-width: 20px;
`;

export const SearchRecent: React.FC<SearchRecentProps> = ({
  histories,
  onRemoveSearchHistories,
  onSearch,
  selected,
  onHoverItem,
}: SearchRecentProps) => {
  return (
    <>
      <StyledSearchTitle>
        <Text fontWeight="500" textTransform="uppercase" color="#82869E">
          {t('Lịch sử tìm kiếm')}
        </Text>
        <StyledRemoveHistory
          onClick={onRemoveSearchHistories}
          {...getTrackingData({
            isTrackContent: true,
            regionName: 'recentSearch',
            contentName: 'clearHistorySearch',
            target: 'searchProduct',
          })}
        >
          {t('Xóa lịch sử')}
        </StyledRemoveHistory>
      </StyledSearchTitle>
      {histories
        ?.filter((history) => !!history)
        .map((history, index) => (
          <StyledSearchItem
            key={index}
            onClick={() => onSearch(history)}
            selected={index === selected}
            onMouseEnter={() => onHoverItem(index)}
            {...getTrackingData({
              isTrackContent: true,
              regionName: 'recentSearch',
              contentName: history?.query,
              target: 'searchProductResult',
              payload: JSON.stringify({
                screenName: 'searchProduct',
                index,
              }),
            })}
          >
            <StyledIcon name="time-outline" size={20} />
            <div style={{ margin: '0 0.6rem' }}>
              <Text maxLines={1}>{history?.query}</Text>
            </div>
          </StyledSearchItem>
        ))}
    </>
  );
};
